const Module1Config = {
  day1: {
    learn: {
      video: 'Module1Videos/learn_day_1.mp4',
      song: 'appfiles/eye_contact/school_photo_montage_music_1.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_day_1.mp4',
    },
    rewardOption1: 'SurfBoardBlue',
    rewardOption2: 'SurfBoardRed',
  },
  day2: {
    learn: {
      video: 'Module1Videos/learn_day_2.mp4',
      song: 'appfiles/eye_contact/school_photo_montage_music_2.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_day_2.mp4',
    },
    rewardOption1: 'UmbrellaRed',
    rewardOption2: 'UmbrellaGreen',
  },
  day3: {
    learn: {
      video: 'Module1Videos/learn_day_3.mp4',
      song: 'appfiles/eye_contact/school_photo_montage_music_3.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_day_3.mp4',
    },
    rewardOption1: 'BeachChairRed',
    rewardOption2: 'BeachChairBlue',
  },
  day4: {
    introVideo: 'Module1Videos/welcome_day_4.mp4',
    rewardOption2: 'FloatationInnerTube',
    rewardOption1: 'FloatationBall',
    photoTime: {
      video1: 'Module1Videos/photo_time_1.mp4',
      video2: 'Module1Videos/photo_time_2.mp4',
    },
    singingTime: {
      intro: 'Module1Videos/singing_time.mp4',
      demoMusic: 'appfiles/eye_contact/eye_contact_student_demo.m4a',
      singAlongMusic: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      instrumentalMusic:
        'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      singingAlongVideo:
        'appfiles/eye_contact/eye_contact_singingtime_singalong.mp4',
      instrumentalVideo:
        'appfiles/eye_contact/eye_contact_singingtime_instrumental.mp4',
    },
  },
  day5: {
    introVideo: 'Module1Videos/welcome_day_5.mp4',
    rewardOption1: 'OceanBoat',
    rewardOption2: 'OceanWhale',
    learn: {
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_intro_day_5.mp4',
      afterVideo: 'Module1Videos/celebrate_close_day_5.mp4',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption2: 'SandCastle',
    rewardOption1: 'SandBucket',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_intro_day_6.mp4',
      afterVideo: 'Module1Videos/celebrate_close_day_6.mp4',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption2: 'SeashellsGreen',
    rewardOption1: 'SeashellsRed',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_intro_day_7.mp4',
      afterVideo: 'Module1Videos/celebrate_close_day_7.mp4',
      animal: true,
      text: 'Record yourself singing, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption2: 'BeachwearSnorkle',
    rewardOption1: 'BeachwearSandles',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_intro_day_8.mp4',
      afterVideo: 'Module1Videos/celebrate_close_day_8.mp4',
      animal: true,
      text: 'Record yourself making a silly face and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: 'Module1Videos/closing.mp4',
    rewardOption2: 'CrabWearMustache',
    rewardOption1: 'CrabWearGlasses',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      recording: 'userfiles/{student-id}/eye_contact_play_day_music.m4a',
      demoSong: 'appfiles/eye_contact/eye_contact_student_singalong.m4a',
      json: 'appfiles/eye_contact/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: 'Module1Videos/celebrate_intro_day_9.mp4',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I am awesome!"',
      name: 'eye_contact_celebration_surprise_9.mp4',
    },
    surprise: {
      video: 'Module1Videos/surprise.mp4',
      song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/greet_affirmation.mp4',
        'userfiles/{student-id}/eye_contact_celebration_surprise_5.mp4',
        'userfiles/{student-id}/eye_contact_smile.jpg',
        'influencers/{influencer-id}/eye_contact_video_message.mp4',
        'userfiles/{student-id}/eye_contact_celebration_surprise_8.mp4',
        'userfiles/{student-id}/eye_contact_silly_photo_1.jpg',
        'userfiles/{student-id}/eye_contact_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module1Config;
